import 'elm-pep'; // Pointer events polyfill pre iOS
import 'promise-polyfill/src/polyfill'; // Promise polyfill pre iOS
import "ol/ol.css";
import "./style/mapa.scss";
import VectorLayer from "ol/layer/Vector";
import Map from "ol/Map";
import VectorSource from "ol/source/Vector";
import { getHighlightedPolygonStyle, getLabelStyle, getLineStyle, getOverviewMapStyle, getSelectedPolygonStyle, getStandardPolygonStyle, updateFilterState } from "./common/styles";
import Feature from "ol/Feature";
import {Control, Rotate, Attribution, FullScreen} from 'ol/control';
import {DragPan, MouseWheelZoom, defaults as defaultInteractions, Interaction} from 'ol/interaction';
import {platformModifierKeyOnly} from 'ol/events/condition';
import GraveParser from "./parsers/graveParser";
import ParserBase, { TokenType } from "./parsers/parserBase";
import LineParser from "./parsers/lineParser";
import LabelParser from "./parsers/labelParser";
import {register} from 'ol/proj/proj4';
import {inAndOut, linear} from 'ol/easing';
import * as proj4x from 'proj4';
import spinner from "./img/spinner_static.svg";
import { Collection, View } from "ol";
import { ICintorinConfig, ICintorinMapState, IPrintingData, IPrintingLabels } from "./common/interfaces";
import { clearCurrentOrnaments, loadOrnaments, scaleOrnaments, setOrnamentVisibility, triggerOrnamentUpdate } from "./common/ornaments";
import FilterControl from "./controls/filterControl";
import ZoomHint from "./common/zoomHintInteraction";
import ControlContainer from "./controls/controlContainer";
import PrintControl from "./controls/printControl";
import mapPopup from "./common/popup";
import TileLayer, { SourceType } from 'ol/layer/WebGLTile';
import GeoTIFF from 'ol/source/GeoTIFF';
import TileWMS from 'ol/source/TileWMS';
import OrthomapControl from "./controls/orthomapControl";
import * as debounce from "debounce";
import { Coordinate, rotate } from "ol/coordinate";
import { ARROW_DELAY, CLICKABLE_LAYER_ID, MAP_MOVEMENT_SPEED, MAP_MOVEMENT_STEP, POPUPS_ENABLED_ID } from "./common/constants";
import SettingsControl from "./controls/settingsControl";
import CustomZoomControl from "./controls/customZoomControl";
import { getLocalizedText } from "./common/translations";
import CustomOverviewMap from './controls/customOverviewMap';
import SelectGraveInteraction from './common/selectGraveInteraction';
import { isMobile, isWindowSizeMobile } from './common/utilities';
import LocationControl from './controls/locationControl';
import { initializeToastContainer } from './common/toasts';
import { recalculateCardPosition } from './page';

// zaregistrovanie JTSK projekcie
let proj4 = (proj4x as any).default; // workaround kvoli nekompatibilnym verziam proj4 a @types/proj4
proj4.defs("EPSG:5514", "+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=485,169.5,483.8,7.786,4.398,4.103,0 +units=m +no_defs");
register(proj4);

// type deklaracie aby boli metody dostupne v kode bez toho zeby ich webpack includol do modulu
declare const CintorinConfig:ICintorinConfig;

declare var CintorinPrinter: {
    print:(sourceView: View, printingData :IPrintingData, labels :IPrintingLabels) => void,
}

declare var CintorinKarta: {
    updateGraveCardFromMap:(hIdentifier: string, cId: number, selectedTabIndex: number) => Promise<void>
}

var selectedFeature:Feature = undefined;
var highlightedFeature:Feature = undefined;
var areaSource = new VectorSource();
var areaLayer = new VectorLayer({
    source: areaSource,
    style: getStandardPolygonStyle,
    properties: {"layerId": CLICKABLE_LAYER_ID}
});
var lineSource = new VectorSource();
export var lineLayer = new VectorLayer({
    source: lineSource,
    style: getLineStyle
});
var labelSource = new VectorSource();
var labelLayer = new VectorLayer({
    source: labelSource,
    style: getLabelStyle
});
var overviewSource = new VectorSource();
var ortoLayer = new TileLayer({});
var ortoAttributionLayer = new VectorLayer({source: new VectorSource()});

// inicializacia sipok na posuvanie
var leftArrow = createSvgArrow("M 20,0 0,75 20,150", "0 0 20 150", [-1,0]);
leftArrow.id = "map-arrow-left";
var rightArrow = createSvgArrow("M 0,0 20,75 0,150", "0 0 20 150", [1,0]);
rightArrow.id = "map-arrow-right";
var topArrow = createSvgArrow("M 0,20 75,0 150,20", "0 0 150 20", [0,1]);
topArrow.id = "map-arrow-top";
var bottomArrow = createSvgArrow("M 0,0 75,20 150,0", "0 0 150 20", [0,-1]);
bottomArrow.id = "map-arrow-bottom";
var moveDirection = [0, 0];

//inicializacia spinnera
var loadingDiv = document.createElement("div");
loadingDiv.classList.add("karta-collapsed");
let img = document.createElement("img");
img.src = spinner;
loadingDiv.appendChild(img);
let label = document.createElement("p");
label.innerText = getLocalizedText("mapLoading");
loadingDiv.appendChild(label);
loadingDiv.id = "map-loading-div";

var actualMapDiv = document.createElement("div");
actualMapDiv.id = "actual-map-div";

// inicializacia popupu
var placeNotFoundPopup = document.createElement("div");
placeNotFoundPopup.id = "place-not-found-popup";
placeNotFoundPopup.innerHTML = `<p>?</p><p>`+getLocalizedText("placeNotFound")+`</p>`;
placeNotFoundPopup.style.display = "none";

// inicializacia overview mapy
var customOverviewMap = new CustomOverviewMap({
    layers: [new VectorLayer({
        source: overviewSource,
        style: getOverviewMapStyle()
    })]
});

var leftContainer: ControlContainer;
var ortomapControl: OrthomapControl;
var filterControl: FilterControl;
var settingsControl: SettingsControl;
var locationControl: LocationControl;
var placeholder :HTMLElement;
var section :HTMLElement;
var m: Map;
var taskQueue = Promise.resolve();

var configuration: ICintorinMapState;

document.addEventListener("readystatechange", () => {
    if (document.readyState === 'complete') {
        if (document.getElementById("mapSection")) {
            initialize();
        }
        if (document.getElementById("cardCId")) {
            let cid = +(document.getElementById("cardCId") as HTMLInputElement).value;
            if (document.getElementById("cardIdentifier")) {
                selectGrave((document.getElementById("cardIdentifier") as HTMLInputElement).value, cid);
            } else {
                setMap(cid);
            }
        }
    }
});

// responzivne zobrazenie mapy
var lastWindowStateIsMobile: boolean = false;

window.addEventListener("resize", function () {
    if (!configuration?.mapLoaded)
        return;

    let currentWindowStateIsMobile = isWindowSizeMobile();
    if (currentWindowStateIsMobile != lastWindowStateIsMobile) {
        lastWindowStateIsMobile = currentWindowStateIsMobile;

        if (document.getElementById("toggleArrows").parentElement) {
            document.getElementById("toggleArrows").parentElement.style.display = (lastWindowStateIsMobile ? "none" : "");
        }

        if (lastWindowStateIsMobile) { // mobile layout
            toggleArrows(false);
            customOverviewMap.setCollapsed(true);
            leftContainer.collapseContainer();
        } else { // normal layout
            toggleArrows(settingsControl.arrowsVisible);
        }
    }
});

// mala by sa volat len raz
export function initialize() {

    configuration = {
        initialized: false,
        mapLoaded: false,
        mapAvailable: false,
        printingLabels: {
            cemeteryName: "",
            cityName: "",
            lastUpdate: ""
        }
    };
    section = document.getElementById("mapSection");
    section.classList.add("karta-collapsed");
    placeholder = document.getElementById("map-placeholder");
    placeholder.classList.remove("karta-collapsed");
    let targetDiv = document.getElementById("mapContainer") as HTMLDivElement;
    targetDiv.style.position = "relative";
    targetDiv.appendChild(leftArrow);
    targetDiv.appendChild(rightArrow);
    targetDiv.appendChild(topArrow);
    targetDiv.appendChild(bottomArrow);
    targetDiv.appendChild(actualMapDiv);
    targetDiv.appendChild(loadingDiv);
    targetDiv.appendChild(placeNotFoundPopup);

    m = new Map({
        controls: initializeControls(targetDiv),
        interactions: initializeInteractions(),
        layers: [
            areaLayer,
            labelLayer,
            lineLayer,
            ortoLayer,
            ortoAttributionLayer
        ],
        overlays: [mapPopup],
        target: actualMapDiv,
        view: new View({
            projection: "EPSG:5514"
        })
    });
    initializeToastContainer(m.getViewport());
    m.set(POPUPS_ENABLED_ID, true);
    m.on("moveend", function (e) {
        scaleOrnaments(e.map.getView().getResolution());
    });

    if (/iPad/i.test(navigator.userAgent)) {
        targetDiv.addEventListener("touchstart", handleMouseEnter);
    } else {
        targetDiv.addEventListener("mouseenter", handleMouseEnter);
        targetDiv.addEventListener("mouseleave", handleMouseLeave);
    }
    configuration.initialized = true;
}

export function setMap(newId: number) {
    let cardPlaceholderMapLoaded = document.getElementById("cardPlaceholderMapLoaded");
    let cardPlaceholderNoMap = document.getElementById("cardPlaceholderNoMap");
    cardPlaceholderMapLoaded?.classList.add("karta-collapsed");
    cardPlaceholderNoMap?.classList.remove("karta-collapsed");
    if (!configuration.initialized)
        return;
    if (configuration.cintorinId === newId)
        return;
    configuration.mapLoaded = false;
    if (typeof(newId) === "undefined") {
        configuration.cintorinId = undefined;
        if (placeholder) {
            placeholder.classList.remove("karta-collapsed");
        }
        if (section) {
            section.classList.add("karta-collapsed");    
        }
        document.getElementById("map-hints")?.classList.add("karta-collapsed");
        return;
    }
    clearMap();
    placeholder.classList.add("karta-collapsed");
    section.classList.remove("karta-collapsed");
    document.getElementById("map-hints").classList.remove("karta-collapsed");
    m.updateSize();
    loadingDiv.getElementsByTagName("p").item(0).innerText = getLocalizedText("mapLoading");
    loadingDiv.getElementsByTagName("img").item(0).style.visibility = "visible";
    loadingDiv.classList.remove("karta-collapsed");

    configuration.cintorinId = newId;
    cardPlaceholderMapLoaded?.classList.remove("karta-collapsed");
    cardPlaceholderNoMap?.classList.add("karta-collapsed");
    taskQueue = taskQueue.then(async () => {
        let results = await Promise.allSettled([loadMap(newId), loadMapInfo(newId)]);
        if (results[0] && configuration.cintorinId === newId) {
            m.render();
            loadingDiv.getElementsByTagName("img").item(0).style.visibility = "inherit";
            loadingDiv.classList.add("karta-collapsed");
            customOverviewMap.setCollapsed(isWindowSizeMobile());
            configuration.mapLoaded = true;
        }
    });
}

export function selectGrave(locationId: string, cintorinId:number) {
    if (cintorinId !== configuration.cintorinId) {
        setMap(cintorinId);
    }
    taskQueue = taskQueue.then(() => {
        if (configuration.mapLoaded) {
            let target = areaSource.getFeatures().find(f => typeof(f.get("graveIds")) !== "undefined" && f.get("graveIds").findIndex((id:string) => id === locationId) > -1);
            selectedFeature?.setStyle();
            selectedFeature = undefined;
            highlightedFeature?.setStyle();
            highlightedFeature = undefined;
            if (target) {
                selectedFeature = target;
                selectedFeature.setStyle(getSelectedPolygonStyle);
                let extent = selectedFeature.getGeometry().getExtent();
                let targetResolution = m.getView().getResolutionForExtent(extent, [100, 100]);
                let targetZoom = m.getView().getZoomForResolution(targetResolution);
                m.renderSync();
                m.getView().animate({
                    center: [(extent[2]+extent[0])/2.0, (extent[3]+extent[1])/2.0],
                    duration: 1000,
                    zoom: targetZoom,
                    easing: inAndOut
                });
            } else if (locationId != "") { // mam hrob no nie miesto na mape
                placeNotFoundPopup.style.display = "none";
                placeNotFoundPopup.style.animationName = "";
                placeNotFoundPopup.style.display = "flex";
                placeNotFoundPopup.style.animationName = "placeNotFound";
                setTimeout(() => {
                    placeNotFoundPopup.style.display = "none";
                }, 10000);
            }
        }
    });
}

export function reset() {
    taskQueue = taskQueue.then(() => {
        section.classList.add("karta-collapsed");
        placeholder.classList.remove("karta-collapsed");
        clearMap();
    });
}

export function refreshOrnaments() {
    triggerOrnamentUpdate();
}

function handleMouseEnter() {
    leftArrow.classList.remove("collapse");
    rightArrow.classList.remove("collapse");
    topArrow.classList.remove("collapse");
    bottomArrow.classList.remove("collapse");
}

function handleMouseLeave() {
    leftArrow.classList.add("collapse");
    rightArrow.classList.add("collapse");
    topArrow.classList.add("collapse");
    bottomArrow.classList.add("collapse");
}

function getStartMovingMapHandler(direction: Coordinate) {
    return function () {
        let rotation = m.getView().getRotation();
        moveDirection = direction;
        rotate(moveDirection, rotation);
        moveMap();
    }
}

function handleStopMovingMap() {
    moveDirection = [0,0];
}

function moveMap() {
    m.renderSync();
    let newCenter = [...m.getView().getCenter()];
    let distance = m.getView().getResolution() * MAP_MOVEMENT_SPEED;
    newCenter[0] += moveDirection[0]*distance;
    newCenter[1] += moveDirection[1]*distance;
    m.getView().animate({
        center: newCenter,
        easing: linear,
        duration: MAP_MOVEMENT_STEP
    });
    if (moveDirection[0] != 0 || moveDirection[1] != 0) {
        setTimeout(moveMap, MAP_MOVEMENT_STEP);
    }
}

function clearMap() {
    customOverviewMap.setCollapsed(true);
    // remove ornaments only
    let overlays = m.getOverlays();
    overlays.forEach(o => {
        if (o != mapPopup) {
            m.removeOverlay(o);
        }
    });
    areaSource.clear(true);
    lineSource.clear(true);
    overviewSource.clear(true);
    labelSource.clear(true);
    selectedFeature = undefined;
    highlightedFeature = undefined;
}

export function highlightFeature(newHighlight: Feature) {
    if (newHighlight?.getId() != selectedFeature?.getId()) {
        highlightedFeature?.setStyle();
        highlightedFeature = newHighlight;
        highlightedFeature?.setStyle(getHighlightedPolygonStyle);
    }
}

export function selectFeature(newSelection: Feature, selectedTab:number, coordinate: Coordinate) {
    selectedFeature?.setStyle();
    selectedFeature = undefined;
    highlightedFeature?.setStyle();
    highlightedFeature = undefined;
    if (newSelection) {
        selectedFeature = newSelection;
        selectedFeature.setStyle(getSelectedPolygonStyle);
        let extent = selectedFeature.getGeometry().getExtent();
        let targetResolution = m.getView().getResolutionForExtent(extent, [100, 100]);
        let targetZoom = m.getView().getZoomForResolution(targetResolution);
        m.renderSync();
        m.getView().animate({
            center: [(extent[2]+extent[0])/2.0, (extent[3]+extent[1])/2.0],
            duration: 1000,
            zoom: targetZoom,
            easing: inAndOut
        });
        let graves = selectedFeature.get("graveIds");
        if (graves && graves.length > 0) {
            CintorinKarta.updateGraveCardFromMap(graves.join(" "), configuration.cintorinId, selectedTab);
        } else {
            CintorinKarta.updateGraveCardFromMap("", configuration.cintorinId, selectedTab);
        }
    } else {
        if (coordinate) {
            m.getView().animate({
                center: coordinate,
                duration: 1000,
                easing: inAndOut
            });
        }
        CintorinKarta.updateGraveCardFromMap("", configuration.cintorinId, selectedTab);
    }
}

async function loadMap(newId: number) {
    clearCurrentOrnaments();
    await fetch(CintorinConfig.baseUrl+"/api/getMap.php",  {
        method: "POST",
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: "cId="+encodeURIComponent(newId)
    })
    .then(response => {
        if (response.ok)
            return response.arrayBuffer();
        else
            handleError();
    }, handleError)
    .then(dataBuffer => {
        if (configuration.cintorinId !== newId)
            return false;
        if (dataBuffer) {
            let decoder = new TextDecoder("windows-1250");
            let text = decoder.decode(dataBuffer);
            processFile(text);
            return true;
        }
        return false;
    }).then(mapLoaded => {
        if (mapLoaded) {
            loadOrnaments(newId, m, CintorinConfig.baseUrl);
        }
        return mapLoaded;
    });
}

async function loadMapInfo(newId: number) {
    toggleOrtoMap(false);
    await (fetch(CintorinConfig.baseUrl+"/api/getMapInfo.php",  {
        method: "POST",
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: "cId="+encodeURIComponent(newId)
    }).then(response => {
        if (response.ok && response.status == 200)
            return response.json();
    }).then(dataJson => {
        let mapy = dataJson.ortofotoMap || [];
        let ortoSource:SourceType = null;
        let attribution = "";
        let extent = lineLayer.getExtent();
        if (mapy.length > 0) {
            ortoSource = new GeoTIFF({
                sources: [
                    { url: CintorinConfig.baseUrl+"/api/getOrthoMap.php?cId="+newId }
                ],
            });
            attribution = "Ortofoto © "+mapy[0].attribution;
            extent = mapy[0].extent;
        } else if (dataJson.hasMap) {
            ortoSource = new TileWMS({
                url: "https://zbgisws.skgeodesy.sk/zbgis_ortofoto_wms/service.svc/get",
                params: {
                    "LAYERS" : "1"
                }
            });
            attribution = "Ortofoto © GKÚ 2023";
        }

        if (ortoSource) {
            if (attribution)
                ortoAttributionLayer.getSource().setAttributions(attribution);
            ortoLayer.setExtent(extent);
            ortoLayer.setSource(ortoSource);
            ortoLayer.setOpacity(0.5);
            toggleOrtoMap(false);
            ortomapControl.reset(true, CintorinConfig.orthoVisibleByDefault ?? true);
            toggleOrtoMap(CintorinConfig.orthoVisibleByDefault ?? true);
        } else {
            ortomapControl.reset(false, CintorinConfig.orthoVisibleByDefault ?? true);
            ortoLayer.setVisible(false);
            ortoAttributionLayer.setVisible(false);
        }

        if (filterControl) {
            filterControl.setPaymentFiltersVisibility(dataJson.isMarianum ? false : true);
        }

        configuration.mapAvailable = dataJson.hasMap;
        configuration.printingLabels = {
            cemeteryName: dataJson.cemeteryName,
            cityName: dataJson.cityName,
            lastUpdate: dataJson.lastMapUpdate
        };
    }));
}

function processFile(rawData: string) {
    let polygonParser = new GraveParser(rawData);
    processFeatures(polygonParser, areaSource);
    if (filterControl) {
        filterControl.updateFilterOptions(polygonParser.graveTypes.sort());
    }
    let lineParser = new LineParser(rawData);
    processFeatures(lineParser, lineSource);
    overviewSource.addFeatures(lineSource.getFeatures().filter(f => !f.get("hrob")));
    let labelParser = new LabelParser(rawData);
    processFeatures(labelParser, labelSource);
    let extent = labelParser.getExtent();
    m.getView().setMinZoom(1);
    m.getView().setMaxZoom(28);
    m.getView().fit(extent, {size: m.getSize()});
    m.getView().setMinZoom(m.getView().getZoom());
    m.getView().setMaxZoom(m.getView().getZoomForResolution(0.01));
}

function processFeatures(parser: ParserBase, source: VectorSource) {
    let counter = 0;
    while (parser.getCurrentTokenType() !== TokenType.EOF) {
        let feature = parser.parseFeature();
        if (feature) {
            counter++;
            feature.setId(counter);
            source.addFeature(feature);
        }
    }
}

function handleError() {
    loadingDiv.getElementsByTagName("img").item(0).style.visibility = "hidden";
    loadingDiv.getElementsByTagName("p").item(0).innerText = getLocalizedText("mapLoadingError");
}

function toggleOrtoMap(isVisible: boolean) {
    ortoLayer.setVisible(isVisible);
    ortoAttributionLayer.setVisible(isVisible);
}

function changeOrtoOpacity(opacity: number) {
    ortoLayer.setOpacity(opacity);
}

function toggleArrows(arrowsVisible: boolean) {
    let arrows = document.getElementsByClassName("map-arrow");
    for (let i = 0; i<arrows.length; i++) {
        if (arrowsVisible) {
            arrows.item(i).classList.remove("invisible");
        } else {
            arrows.item(i).classList.add("invisible");
        }
    }
    m.updateSize();
}

function toggleOrnaments(ornamentsVisible: boolean) {
    let ornaments = actualMapDiv.querySelectorAll(".ozdoba");
    ornaments.forEach(function(o) {
        if (ornamentsVisible) {
            o.classList.remove("ozdoba-hide");
        } else {
            o.classList.add("ozdoba-hide");
        }
    });
    setOrnamentVisibility(ornamentsVisible);
}

function initializeControls(mapContainer: HTMLDivElement):Collection<Control> {
    let result = new Collection<Control>();

    leftContainer = new ControlContainer({
        orientation: "left",
        collapsible: true
    });
    result.push(leftContainer);
    filterControl = new FilterControl({
        filterStateChangeHandler: (newState) => {
            updateFilterState(newState);
            areaSource.changed();
        },
        tooltipContainer: mapContainer
    });
    filterControl.setTarget(leftContainer.containerElement);
    result.push(filterControl);
    settingsControl = new SettingsControl({
        arrowVisibilityChanged: toggleArrows,
        ornamentVisibilityChanged: toggleOrnaments,
        tooltipContainer: mapContainer
    });
    settingsControl.setTarget(leftContainer.containerElement);
    result.push(settingsControl);
    let printControl = new PrintControl({
        clickHandler: printMap,
        target: leftContainer.containerElement,
        tooltipContainer: mapContainer
    });
    result.push(printControl);
    result.push(new CustomZoomControl({
        target: leftContainer.containerElement,
        tooltipContainer: mapContainer
    }));
    ortomapControl = new OrthomapControl({
        target: leftContainer.containerElement,
        mapToggledHandler: toggleOrtoMap,
        opacityChangedHandler: changeOrtoOpacity,
        tooltipContainer: mapContainer
    });
    result.push(ortomapControl);
    if (hasGeolocation()) {
        locationControl = new LocationControl({
            target: leftContainer.containerElement
        });
        result.push(locationControl);
    }
    let compassIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg"); // Bootstrap Arrow up
    compassIcon.setAttribute("width", "24px");
    compassIcon.setAttribute("height", "24px");
    compassIcon.setAttribute("viewBox", "0 0 16 16");
    compassIcon.innerHTML = `<path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/>`;
    compassIcon.classList.add("symbol");
    let compassContainer = document.createElement("div");
    compassContainer.appendChild(compassIcon);
    result.push(new Rotate({
        label: compassContainer,
        target: leftContainer.containerElement
    }));
    let rightContainer = new ControlContainer({ orientation: "top-right"});
    result.push(rightContainer);
    customOverviewMap.setTarget(rightContainer.containerElement);
    result.push(customOverviewMap);
    let bottomRightContainer = new ControlContainer({ orientation: "bottom-right"});
    result.push(bottomRightContainer);
    let fullscreenControl = new FullScreen({
        target: bottomRightContainer.containerElement,
        source: document.getElementById("mapFullscreenContainer")
    });
    fullscreenControl.on("enterfullscreen", () => {m.set("isFullscreen", true);});
    fullscreenControl.on("leavefullscreen", () => {
        m.set("isFullscreen", false);
        document.getElementById("karta").classList.remove("fullscreen-expanded");
        recalculateCardPosition();
    });
    result.push(fullscreenControl);
    result.push(new Attribution({
        target: bottomRightContainer.containerElement
    }));
    return result;
}

function initializeInteractions():Collection<Interaction> {
    if (isMobile()) {
        return defaultInteractions({ // prevzate z https://openlayers.org/en/latest/examples/two-finger-pan-scroll.html
            dragPan: false,
            mouseWheelZoom: false
        }).extend([
            new MouseWheelZoom({condition: platformModifierKeyOnly}),
            new DragPan({condition: function(event) { return m.get("isFullscreen") || (this as any).getPointerCount() === 2 || platformModifierKeyOnly(event) }}),
            new SelectGraveInteraction(),
            new ZoomHint()
        ]);
    } else {
        return defaultInteractions().extend([new SelectGraveInteraction()]);
    }
}

function printMap() {
    CintorinPrinter.print(
        m.getView(), 
        {
            graves: areaSource,
            labels: labelSource,
            lines: lineSource
        },
        configuration.printingLabels
    );
}

function createSvgArrow(pathString: string, viewBox: string, direction: Coordinate) {
    let result = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    result.setAttribute("viewBox", viewBox);
    let path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", pathString);
    if (/iPad/i.test(navigator.userAgent)) {
        path.ontouchstart = debounce(getStartMovingMapHandler(direction), ARROW_DELAY);
        path.addEventListener("touchend", function () {
            (this.ontouchstart as any).clear();
            moveDirection = [0,0];        
        });
    } else if (isMobile()) {
        path.addEventListener("pointerdown", getStartMovingMapHandler(direction));
        path.addEventListener("pointerup", handleStopMovingMap);
    } else {
        path.onmouseenter = debounce(getStartMovingMapHandler(direction), ARROW_DELAY);
        path.addEventListener("mouseleave", handleStopMovingMap);
    }
    result.appendChild(path);
    result.classList.add("map-arrow");
    result.classList.add("invisible");
    return result;
}

function hasGeolocation() {
    //let cookie = document.cookie.split("; ").find((r)=> r.startsWith("experimental"));
    return /*(typeof(cookie) !== "undefined") && */ navigator.geolocation;
}